import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {useTable} from "react-table";
import "jspdf-autotable";
import {useForm} from "react-hook-form";

function AccountManagerUsage(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [data, setData] = useState([]);
    const [bankName, setBankName] = useState();
    const [bankAddress, setBankAddress] = useState();
    const [bankCity, setBankCity] = useState();
    const [bankZip, setBankZip] = useState([]);
    const [bankPhone, setBankPhone] = useState();
    const [country, setCountry] = useState();
    const [region, setRegion] = useState();
    const [resetUserForm, setResetUserForm] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();
    //  Internally, customStyles will deep merges your customStyles with the default styling.

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            width: "9vw",
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {

        const getUsers = async () => {
            console.log(" GET USERS BY LIST")
            var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
            const result=null;
            // const result = await axios.get(`${getUserViewListApi}?id=${loggedUserStorage}`);
            result?.data.unshift(feed);

        };


        getUsers();
        return () => {
            setData([]);
        };
    }, [location]);


    useEffect(() => {
        const terminalId = location?.search?.split("=")?.[1];
        const getLocationandTerminals = async () => {
            //const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;
            //console.log(" GET LOCATION BY USERID BY SELECTED USER",selectedUserByDefault)
            //const resultTerminal = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${selectedUserByDefault}&paramByType=TERMINAL&paramSearchCriteria=`);
            const resultTerminal=null;

        };

        getLocationandTerminals();
        return () => {
            //setVisibleToUserSelectData([]);
        };
    }, [resetUserForm]);

    const handleReset = async (e) => {
        console.log(" resetting form")
    };
    const handleGetReport = async () => {
        try {
            console.log(" bankName ",bankName)
            console.log(" bankAddress ",bankAddress)
            /*const result = await axios.get(`${getTerminalTxnHistory}?paramRTA=${rtaNumber}&parambankName=${bank}&paramSettSchedule=${selectedSettlementScheduleOrder.value}&paramSurchargeSchedule=${selectedSurchargeScheduleOrder.value}&paramIntSchedule=${selectedInterchangeScheduleOrder.value}
            &paramConsolidation=${selectedConsolidationOrder.value}&paramUserID=${selectedVisibleToUser?.value}&paramOwner=${selectedAccountOwner.value}`);
            console.log(" get result data ",result?.data?.response);
            setData(result?.data?.response);*/
        } catch (error) {}
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h5 className="tbsub-title mt-3 mb-3">No Data Available</h5>
                    {/*<form>
                        <div className="row mt-4">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">
                                    <label>Bank Name:</label>
                                    <div>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            style={{ width: "15.5vw" }}
                                            onChange={(e) =>
                                                setBankName(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between ">
                                    <label>Bank Address:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            onChange={(e) =>
                                                setBankAddress(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank City:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            onChange={(e) =>
                                                setBankCity(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank Region:</label>
                                    <div>
                                        <select name="paramRegion" onChange={(e) =>setRegion((e.target.value))}
                                                className="form-control form-control-sm col-md-12" style={{width: "15.5vw"}}>
                                            <option value="14">Alaska</option>
                                            <option value="15">Alabama</option>
                                            <option value="16">Arkansas</option>
                                            <option value="17">Arizona</option>
                                            <option selected="selected" value="18">California</option>
                                            <option value="19">Colorado</option>
                                            <option value="20">Connecticut</option>
                                            <option value="21">District of Columbia</option>
                                            <option value="22">Delaware</option>
                                            <option value="23">Florida</option>
                                            <option value="24">Georgia</option>
                                            <option value="25">Hawaii</option>
                                            <option value="26">Iowa</option>
                                            <option value="27">Idaho</option>
                                            <option value="28">Illinois</option>
                                            <option value="29">Indiana</option>
                                            <option value="30">Kansas</option>
                                            <option value="31">Kentucky</option>
                                            <option value="32">Louisiana</option>
                                            <option value="33">Massachusetts</option>
                                            <option value="34">Maryland</option>
                                            <option value="35">Maine</option>
                                            <option value="36">Michigan</option>
                                            <option value="37">Minnesota</option>
                                            <option value="38">Missouri</option>
                                            <option value="39">Mississippi</option>
                                            <option value="40">Montana</option>
                                            <option value="41">North Carolina</option>
                                            <option value="42">North Dakota</option>
                                            <option value="43">Nebraska</option>
                                            <option value="44">New Hampshire</option>
                                            <option value="45">New Jersey</option>
                                            <option value="46">New Mexico</option>
                                            <option value="47">Nevada</option>
                                            <option value="48">New York</option>
                                            <option value="49">Ohio</option>
                                            <option value="50">Oklahoma</option>
                                            <option value="51">Oregon</option>
                                            <option value="52">Pennsylvania</option>
                                            <option value="53">Rhode Island</option>
                                            <option value="54">South Carolina</option>
                                            <option value="55">South Dakota</option>
                                            <option value="56">Tennessee</option>
                                            <option value="57">Texas</option>
                                            <option value="58">Utah</option>
                                            <option value="59">Virginia</option>
                                            <option value="60">Vermont</option>
                                            <option value="61">Washington</option>
                                            <option value="62">Wisconsin</option>
                                            <option value="63">West Virginia</option>
                                            <option value="64">Wyoming</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between ">
                                    <label>Bank Country:</label>
                                    <div>
                                        <select name="paramCountry" onChange={(e) =>setCountry((e.target.value))}
                                                className="form-control form-control-sm col-md-12" style={{width: "15.5vw"}}>
                                            <option value="NA">Select Country</option>
                                            <option  selected="selected" value="USA">United States</option>
                                            <option value="MEX">Mexico</option>
                                            <option value="EUR">Europe</option>
                                            <option value="CAN">Canada</option>
                                            <option value="IND">India</option>
                                            <option value="UK">United Kingdom</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>ZipCode:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            onChange={(e) =>
                                                setBankZip(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank Phone:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            onChange={(e) =>
                                                setBankPhone(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center mt-1 align-items-center">
        <span
            class="input-group-text"
            role="button"
            onClick={() => handleGetReport()}>Save</span>

                        </div>
                    </form>*/}
                </div>
            </div>
        </div>
    );
}

export default AccountManagerUsage;
